import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as spaceUse from '../../space-use'

export const RESOURCE = {
  payload: {
    description:
      'A slightly more granular classification of how a space is used. This could include "Blood Collection", "Computer Classroom", or "Injection", for example.',
    dimension: spaceUse.RESOURCE.payload,
    level: 1,
    name: 'Room Type',
    partialId: PartialId.Standard.create('type'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
